import PropTypes from "prop-types";

// Components
import { Card } from "./Card";

export const CardContainer = (props) => {
    return <Card {...props} />;
};

CardContainer.defaultProps = { data: {} };

CardContainer.propTypes = { data: PropTypes.object, onClick: PropTypes.func };
